if (!customElements.get('count-down')) {
  customElements.define('count-down', class Countdown extends HTMLElement {
    constructor() {
      super();

      this.needReverseTime = false;
      this._boundOnVariantChanged = this.onVariantChanged.bind(this);
      this._mutationObserver = null;
      this._variantWatchInterval = null;
      this._lastVariantId = null;
      if(!this.dataset.hasOwnTpl) {
        this.appendChild(document.getElementById('countdown-tpl').content.firstElementChild.cloneNode(true));
      }
      this.applyPreorderVisibility();

      if(this.dataset.endtime) {
        this.initSingleCountdown();
      } else if(this.dataset.list) {
        this.initCountdownInList();
      } else {
        this.initFail();
      }
    }


    connectedCallback() {
      this.bindVariantListeners();
      // Re-check once connected (some themes set variant after hydration)
      this.applyPreorderVisibility();
    }

    disconnectedCallback() {
      this.unbindVariantListeners();
      if (this._mutationObserver) {
        this._mutationObserver.disconnect();
        this._mutationObserver = null;
      }
      if (this._variantWatchInterval) {
        clearInterval(this._variantWatchInterval);
        this._variantWatchInterval = null;
      }
    }

    bindVariantListeners() {
      // Common theme events (best effort)
      document.addEventListener('variant:change', this._boundOnVariantChanged);
      document.addEventListener('variantChange', this._boundOnVariantChanged);
      document.addEventListener('product:variant-change', this._boundOnVariantChanged);
      document.addEventListener('change', this._boundOnVariantChanged, true);

      // Fallback: observe the variant id input in the closest product form
      const form = this.closest('form[action*="/cart/add"]') || this.closest('form');
      if (!form) return;

      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;

      this._mutationObserver = new MutationObserver(() => this.applyPreorderVisibility());
      this._mutationObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });



      const onlyPreorder = (this.dataset.onlyPreorder || '').toString() === 'true';
      if (onlyPreorder) {
        this._lastVariantId = variantInput.value ? String(variantInput.value) : null;
        this._variantWatchInterval = setInterval(() => {
          const current = variantInput.value ? String(variantInput.value) : null;
          if (current && current !== this._lastVariantId) {
            this._lastVariantId = current;
            this.applyPreorderVisibility();
          }
        }, 200);
      }
    }

    unbindVariantListeners() {
      document.removeEventListener('variant:change', this._boundOnVariantChanged);
      document.removeEventListener('variantChange', this._boundOnVariantChanged);
      document.removeEventListener('product:variant-change', this._boundOnVariantChanged);
      document.removeEventListener('change', this._boundOnVariantChanged, true);
    }

    onVariantChanged(event) {
      // Run cheap visibility check, ignore noisy changes
      this.applyPreorderVisibility(event);
    }

    setVisible(isVisible) {
      // hidden peut être override par du CSS; on force aussi via style inline
      this.hidden = !isVisible;
      this.style.display = isVisible ? '' : 'none';
    }

    applyPreorderVisibility(event = null) {
      console.log('[count-down] applyPreorderVisibility enter', {
        onlyPreorder: this.dataset.onlyPreorder,
        preorderVariantIds: this.dataset.preorderVariantIds,
        eventDetail: event?.detail,
        ts: Date.now()
      });
      const onlyPreorder = (this.dataset.onlyPreorder || '').toString() === 'true';
      if (!onlyPreorder) {
        this.setVisible(true);
        console.log('[count-down] onlyPreorder=false => show', { hidden: this.hidden, ts: Date.now() });
        return;
      }

      const preorderSet = this.getPreorderVariantIdSet();
      // If merchant enabled the option but no preorder variants are configured, hide (safe default)
      if (preorderSet.size === 0) {
        this.setVisible(false);
        console.log('[count-down] preorderSet empty => hide', { hidden: this.hidden, ts: Date.now() });
        return;
      }

      const currentVariantId = this.getCurrentVariantId(event);
      if (!currentVariantId) {
        // If we cannot resolve the current variant, hide to avoid wrong display
        this.setVisible(false);
        console.log('[count-down] currentVariantId null => hide', { hidden: this.hidden, ts: Date.now() });
        return;
      }

      const isVisible = preorderSet.has(currentVariantId);
      this.setVisible(isVisible);
      console.log('[count-down] visibility computed', {
        currentVariantId,
        isPreorder: preorderSet.has(currentVariantId),
        hidden: this.hidden,
        ts: Date.now()
      });
    }

    getPreorderVariantIdSet() {
      const raw = (this.dataset.preorderVariantIds || '').trim();
      if (!raw) return new Set();
      return new Set(
        raw
          .split(',')
          .map(s => s.trim())
          .filter(Boolean)
      );
    }

    getCurrentVariantId(event = null) {
      // 1) If event carries a variant id somewhere (best effort)
      const candidate =
        event?.detail?.variant?.id ||
        event?.detail?.variantId ||
        event?.detail?.id ||
        event?.variant?.id ||
        null;
      if (candidate) return String(candidate);

      // 2) Read from closest add-to-cart form input[name="id"]

      const scope =
        this.closest('product-info') ||
        this.closest('section') ||
        this.closest('[data-section-id]') ||
        document;

      const input =
        scope.querySelector('form[action*="/cart/add"] input[name="id"]') ||
        scope.querySelector('input[name="id"]');

      if (!input || !input.value) return null;
      return String(input.value);
    }


    initSingleCountdown() {
      const pattern1 = /^\d{4}-\d{2}-\d{2}$/;
      const pattern2 = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
      const pattern3 = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(\:\d{2}|)(\+|-)\d{4}/;
      const pattern4 = /^\d{2}:\d{2}$/;
      if(pattern1.test(this.dataset.endtime) || pattern2.test(this.dataset.endtime) || pattern3.test(this.dataset.endtime) || pattern4.test(this.dataset.endtime)) {
        var finalDate = this.dataset.endtime.replace(/-/g, '/');
        if(!pattern4.test(this.dataset.endtime)) {
          if(pattern1.test(this.dataset.endtime)) {
            finalDate += ' 00:00:00' + this.dataset.timezone;
          } else if(pattern2.test(this.dataset.endtime)) {
            finalDate += ':00' + this.dataset.timezone;
          }
          this.countDownDate = new Date(finalDate).getTime();
        } else {
          var expiredDate = new Date(this.dataset.reverseTime);
          const currentDate = new Date(this.dataset.nowTime);
          if(expiredDate.getTime() <= currentDate.getTime()) {
            expiredDate.setTime(expiredDate.getTime() + 24 * 60 * 60 * 1000);
          }
          this.countDownDate = expiredDate.getTime();
          this.needReverseTime = true;
        }
        this.initElements();
        this.interval = setInterval(this.run.bind(this), 1000);  
      } else {
        this.initFail();
      }
    }

    initCountdownInList() {
      const pattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(\:\d{2}|)(\+|-)\d{4}/;
      const dataList = this.dataset.list.split(',');
      const now = new Date();
      let min;
      dataList.forEach(value => {
        if(pattern.test(value)) {
          let countdownDate = new Date(value.replace(/-/g, '/'));
          if(countdownDate > now) {
            if(!min || countdownDate <= min) {
              min = countdownDate;
            }
          }
        }
      });
      if(min) {
        this.countDownDate = min.getTime();
        this.initElements();
        this.interval = setInterval(this.run.bind(this), 1000);
      } else {
        this.initFail();
      }
    }

    initElements() {
      this.daysElement = this.querySelector('.countdown__days__value');
      this.hoursElement = this.querySelector('.countdown__hours__value');
      this.minutesElement = this.querySelector('.countdown__minutes__value');
      this.secondsElement = this.querySelector('.countdown__seconds__value');
    }

    initFail() {
      if(Shopify.designMode) {
        this.showMessage(window.accessibilityStrings.countdownErrorMsg);
      } else {
        this.remove();
      }
    }

    run() {
      const now = new Date().getTime();

      // Find the distance between now and the count down date
      const distance = this.countDownDate - now;

      if(distance > 0) {
         // Time calculations for days, hours, minutes and seconds
        const daysNumber = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hoursNumber = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutesNumber = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const secondsNumber = Math.floor((distance % (1000 * 60)) / 1000);
        if(!daysNumber) {
          this.daysElement.parentElement.classList.add('hidden');
        } else {
          this.daysElement.textContent = daysNumber;
        }

        if(!hoursNumber) {
          this.hoursElement.parentElement.classList.add('hidden');
        } else {
          this.hoursElement.textContent = hoursNumber;
        }

        this.minutesElement.textContent = minutesNumber;
        this.secondsElement.textContent = secondsNumber;
      } else {
        if(!this.needReverseTime) {
          clearInterval(this.interval);
          this.showMessage(this.dataset.expiredMsg ? this.dataset.expiredMsg : window.accessibilityStrings.countdownExpiredMsg);
          this.classList.add('expired');
        } else {
          this.countDownDate += 24 * 60 * 60 * 1000;
        }
      }
    }

    showMessage(msg) {
      this.querySelectorAll(':scope > *').forEach((ele) => ele.remove());
      const node = document.createTextNode(msg);
      this.appendChild(node);
    }
  });
}
